export default __webpack_public_path__ + "static/years_bubble_mobile-d17d0eec5bd0e18132ff7b5450f26e50.png";